import DigitalMarketingListing from "./views/pages/digitalMarketingListing.vue";
export const digitalMarketingRouters = [
	{
		path: "/digital-marketing",
		name: "DigitalMarketingListing",
		component: DigitalMarketingListing
	}
];
